import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import ContactListLayer from "../components/ContactListLayer";

const ContactListPage = () => {
    return (
        <MasterLayout>
            <ContactListLayer />
        </MasterLayout>
    );
};

export default ContactListPage;
